import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=604d6552&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports